export const SET_PROGRESS = 'SET_PROGRESS';

export default function setProgress(count) {
  return {
    type: SET_PROGRESS,
    payload: count,
  };
};